// Light callout under the SAI and budget blocks ("What your SAIs mean", "Why we ask for this")
const InsightCard = ({ label, headline, body }) => {
  return (
    <section
      aria-label={label}
      className="bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm"
    >
      <p className="text-xs font-semibold text-primary-500">{label}</p>
      {headline && (
        <p className="text-base font-semibold text-gray-900 mt-1">{headline}</p>
      )}
      <p className="text-sm text-gray-600 mt-1 leading-snug">{body}</p>
    </section>
  );
};

export default InsightCard;
